// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__v+ZAh","controls":"Pagination_controls__YZ5F7","disabled":"Pagination_disabled__1LE7y","active":"Pagination_active__q3h4d"};